const dispatchPage = {
  dispatch: {
    // 待预约 — 预约；dataRes2 与 list.query.checkInStatus 一致，仅 2（温馨入住中 Tab）显示预约（1=新订单 Tab）
    a: {
      dataRes: ['WAIT_APPOINTMENT'],
      dataRes2: ['2'],
      buttonCodes: ['order:dispatcher:booking']
    },
    // 待执行 — 取消预约
    b: {
      dataRes: ['WAIT_EXECUTE'],
      buttonCodes: ['order:dispatcher:booking']
    },
    // 产康项目（整块）
    chanKang: {
      moduleCodes: ['order:dispatcher:ck']
    },
    // 套餐项目分类表（type1/2/3 分开展示，权限独立配置）
    orderProjectArray: {
      type1: { moduleCodes: ['order:dispatcher:projects'] },
      type2: { moduleCodes: ['order:dispatcher:client'] },
      type3: { moduleCodes: ['order:dispatcher:other'] }
    },
    // 左侧列表 — 为她安排专属技师
    assignTechnician: {
      buttonCodes: ['order:dispatcher:js']
    }
  }
}

export default dispatchPage
